import React from 'react';

type Options = IntersectionObserverInit & { once?: boolean };

export function useInViewOnce<T extends HTMLElement>(options: Options = {}) {
  const ref = React.useRef<T | null>(null);
  const [inView, setInView] = React.useState(false);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) {
          setInView(true);
          if (options.once !== false) obs.disconnect();
        } else if (options.once === false) {
          setInView(false);
        }
      },
      { root: options.root, rootMargin: options.rootMargin ?? '0px 0px -10% 0px', threshold: options.threshold ?? 0.15 }
    );

    obs.observe(el);
    return () => obs.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { ref, inView } as const;
}


